import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function SoundPage() {

  return (
    <ProjectLayout
      title="Sound Storm"
      role="Unity Developer (C#) - iOS (iPad)"
      team="2"
      duration="6 Months"
      engine="Unity (C#)"
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/sound.mp4`}
      playLink={`https://www.soundstorm.app/`}
      playText={"SoundStorm Website"}
      galleryImages = {[
    `${process.env.PUBLIC_URL}/img/sound/1.png`,
    `${process.env.PUBLIC_URL}/img/sound/2.png`,
    `${process.env.PUBLIC_URL}/img/sound/3.png`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>
Sound Storm is an iOS application developed in Unity that helps children suffering from Spatial Processing Disorder through a series of interactive games.        </p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
            Through working on Sound Storm, I learned the importance of adhering to strict medical requirements in terms of the implementation of certain hearing test algorithms into the game,
            as well as making sure that the UX is comfortable for children with hearing disabilities. This was a very fulfilling project to work on, and I feel that I learned a lot!
        </p>
      </section>

    
    </ProjectLayout>
  );
}
